import ConveyRoutes from 'src/pages/convey/routes';
import ConvolveRoutes from 'src/pages/convolve/routes';
import TopicRoutes from 'src/pages/topic_modeling/routes';
import ExternalAPIRoutes from 'src/pages/external_api/routes';
import ModelAssessmentRoutes from 'src/pages/model_assessment/routes';
import ConvQLRoutes from 'src/pages/convql/routes';
import StopwordsRoutes from 'src/pages/stopwords/routes';
import AuthRoutes from 'src/pages/auth/routes';

const routes = [
    {
        path: '/ui',
        name: 'root',
        redirect: { name: 'home' },
        component: () => import('layouts/MainLayout.vue'),
        children: [
            {
                name: 'home',
                path: 'home',
                component: () => import('pages/dashboard/home.vue'),
            },
            {
                name: 'download_file',
                path: 'download',
                component: () => import('pages/dashboard/home.vue'),
            },
            ...ConveyRoutes,
            ...ConvolveRoutes,
            ...TopicRoutes,
            ...ExternalAPIRoutes,
            ...ModelAssessmentRoutes,
            ...ConvQLRoutes,
            ...StopwordsRoutes,
        ],
    },
    ...AuthRoutes,
    // Always leave this as last one,
    // but you can also remove it
    {
        path: '/:catchAll(.*)*',
        component: () => import('pages/Error404.vue'),
        name: '404',
    },
];

export default routes;
